import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import {
  buildPriorityTranslationKey,
  buildStatusTranslationKey,
  resolvePriorityTone,
  resolveStatusTone,
} from './supportLabels';

export function TicketStatusBadge({ status }: { status: string }) {
  const { t } = useTranslation('support');
  return <Badge tone={resolveStatusTone(status)}>{t(buildStatusTranslationKey(status))}</Badge>;
}

export function TicketPriorityBadge({ priority }: { priority: string }) {
  const { t } = useTranslation('support');
  return (
    <Badge tone={resolvePriorityTone(priority)}>{t(buildPriorityTranslationKey(priority))}</Badge>
  );
}
